var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDevelopment)?_c('div',{staticClass:"dev-mode"},[_c('p',[_vm._v("Ambiente de homologação")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }